import { FuelButton, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { FormModalUpsell } from 'components/Externals/FormModalUpsell';
import useHandlePlanUpgrade from 'hooks/useHandlePlanUpgrade';
import React, { FC, useState } from 'react';
import PremiumIcon from '../../../../assets/illustrations/premium.svg';
import * as Styled from './styled';

export const BannerPlanUpgrade: FC = () => {
  const { handlePlanUpgradeClick, handleFormModalUpsellEvents } = useHandlePlanUpgrade();

  const [isOpenFormModal, setIsOpenFormModal] = useState(false);

  const handleClick = () => {
    handlePlanUpgradeClick('botao-mudar-de-plano', () => setIsOpenFormModal(true));
  };

  const handleFormModal = () => {
    handleFormModalUpsellEvents('change-plan-ask-for-contact');
    setIsOpenFormModal(false);
  };

  return (
    <>
      <Styled.BannerWrapper>
        <Styled.BannerContent>
          <FuelFlex defaultProps={{ width: '100%', gap: 'km4' }}>
            <FuelFlex defaultProps={{ gap: 'km1', alignItems: 'center' }}>
              <img src={PremiumIcon} alt="premium" />
              <FuelTypography size="heading-sm" weight="bold" color="neutral-inverted" data-testid="title">
                Premium
              </FuelTypography>
            </FuelFlex>
            <FuelFlex defaultProps={{ maxWidth: '370px' }}>
              <FuelTypography size="body-sm" weight="medium" color="neutral-inverted">
                Você está perdendo os contatos de motoristas sugeridos. Assine o Plano Premium para desbloquear seu
                acesso!
              </FuelTypography>
            </FuelFlex>
          </FuelFlex>

          <FuelButton variant="secondary" size="small" inverted onClick={handleClick}>
            Mudar de plano
          </FuelButton>
        </Styled.BannerContent>
      </Styled.BannerWrapper>

      <FormModalUpsell
        isOpen={isOpenFormModal}
        onClose={() => setIsOpenFormModal(false)}
        handleFormModal={handleFormModal}
        toggleFormModal={() => setIsOpenFormModal((prev) => !prev)}
        feature="listamotoristassugeridos"
      />
    </>
  );
};
